import React from "react";
import { Box, Divider, Typography } from "@mui/material";

function Header() {
  return (
    <>
      <Box px={3} py={2} height={64} display={"flex"} alignItems={"center"}>
        <Typography variant="h6">Account Settings</Typography>
      </Box>
      <Divider />
    </>
  );
}

export default Header;
